import React, { useEffect, useRef, useState } from "react";
import style from "./VrtSession.module.sass";
import VrtSessionEditForm from "./VrtSessionEditForm";

function VrtSessionDetail({ patientId, agora, editProps }) {
  const videoRef = useRef(null);
  const [agoraClient, setAgoraClient] = useState(null);
  
  useEffect(() => {
    if (!agora || agora.length === 0) {
      console.error("AGORA == Missing Agora configuration.");
      return;
    }
  
    // Usa il primo elemento dell'array `agora`
    const { channel_name, token, appid } = agora[0];
  
    const initAgora = async () => {
      try {
        console.log("AGORA == start");
  
        const AgoraRTC = window.AgoraRTC;
  
        // Forza la disabilitazione delle statistiche
        AgoraRTC.setParameter("disableLogUpload", true);
        AgoraRTC.setLogLevel(1); // Solo errori
  
        // Initialize Agora Client
        const client = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
        client.setClientRole("audience");
  
        setAgoraClient(client);
  
        const myid = 1234; // Identificatore unico per l'utente
        console.log("AGORA == " + channel_name);
        console.log("AGORA == " + appid);
        console.log("AGORA == " + token);
  
        // Join channel
        await client.join(appid, channel_name, token, myid);
        console.log("AGORA == " + channel_name);
        console.log("AGORA == User joined channel as an audience.");
  
        // Subscribe to user-published event
        client.on("user-published", async (user, mediaType) => {
          console.log("AGORA == User published:", user.uid);
  
          // Subscribe to the user stream
          await client.subscribe(user, mediaType);
          console.log("AGORA == Subscribed to user:", user.uid);
  
          if (mediaType === "video") {
            const videoTrack = user.videoTrack;
            if (videoTrack && videoRef.current) {
              videoTrack.play(videoRef.current);
            }
          }
        });
  
        // Handle user-unpublished event
        client.on("user-unpublished", (user) => {
          console.log("AGORA == User unpublished:", user.uid);
          if (videoRef.current) {
            videoRef.current.innerHTML = ""; // Clear video content
          }
        });
  
        // Handle peer-leave event
        client.on("user-left", (user) => {
          console.log("AGORA == User left:", user.uid);
          if (videoRef.current) {
            videoRef.current.innerHTML = ""; // Clear video content
          }
        });
      } catch (error) {
        console.error("AGORA == Error initializing AgoraRTC:", error);
      }
    };
  
    initAgora();
  
    return () => {
      if (agoraClient) {
        agoraClient.leave().then(() => {
          console.log("Left the Agora channel.");
          agoraClient.removeAllListeners();
        }).catch((err) => console.error("Error leaving Agora channel:", err));
      }
    };
  }, [agora]);

  return (
<div className={style.container}>
      <h2 className={style.title}>Dettaglio sessione</h2>
      <div className={style.content}>
        <div className={style.leftPanel}>
           <div className={style.formGroup}>
           <div className={style.labelBigB}>
           {patientId}
           </div>
           </div>
            <div className={style.formGroup}>

            </div>
          <VrtSessionEditForm editProps={editProps} />
        </div>
        <div className={style.rightPanel}>
          <div
          id="video-container"
          ref={videoRef}
          style={{
            width: "100%",
            height: "500px",
            backgroundColor: "#000",
          }}
          />
        </div>      
      </div>
     
    </div>
  );
}

export default VrtSessionDetail;
